import worldAtlas from '../../data/countries-110m.json';
import usStatesTopo from '../../data/us-states-10m.json';
import canadaProvincesGeo from '../../data/canada-provinces.geojson';
import mexicoStatesGeo from '../../data/mexico-states.geojson';

export type Country = {
  id: string;
  label: string;
  mapName: string;
  code?: string;
};

export type RegionConfig = {
  id: string;
  label: string;
  countries: Country[];
  center?: [number, number];
  geography?: any;
  scaleMultiplier?: number;
  maxScale?: number;
  projection?: string;
};

export const africaCountries: Country[] = [
  { id: 'algeria', label: 'Algeria', mapName: 'Algeria', code: 'DZ' },
  { id: 'angola', label: 'Angola', mapName: 'Angola', code: 'AO' },
  { id: 'benin', label: 'Benin', mapName: 'Benin', code: 'BJ' },
  { id: 'botswana', label: 'Botswana', mapName: 'Botswana', code: 'BW' },
  { id: 'burkina-faso', label: 'Burkina Faso', mapName: 'Burkina Faso', code: 'BF' },
  { id: 'burundi', label: 'Burundi', mapName: 'Burundi', code: 'BI' },
  { id: 'cameroon', label: 'Cameroon', mapName: 'Cameroon', code: 'CM' },
  { id: 'central-african-republic', label: 'Central African Republic', mapName: 'Central African Rep.', code: 'CF' },
  { id: 'chad', label: 'Chad', mapName: 'Chad', code: 'TD' },
  { id: 'congo', label: 'Congo', mapName: 'Congo', code: 'CG' },
  { id: 'democratic-republic-of-congo', label: 'Democratic Republic of Congo', mapName: 'Dem. Rep. Congo', code: 'CD' },
  { id: 'djibouti', label: 'Djibouti', mapName: 'Djibouti', code: 'DJ' },
  { id: 'egypt', label: 'Egypt', mapName: 'Egypt', code: 'EG' },
  { id: 'equatorial-guinea', label: 'Equatorial Guinea', mapName: 'Eq. Guinea', code: 'GQ' },
  { id: 'eritrea', label: 'Eritrea', mapName: 'Eritrea', code: 'ER' },
  { id: 'ethiopia', label: 'Ethiopia', mapName: 'Ethiopia', code: 'ET' },
  { id: 'gabon', label: 'Gabon', mapName: 'Gabon', code: 'GA' },
  { id: 'gambia', label: 'Gambia', mapName: 'Gambia', code: 'GM' },
  { id: 'ghana', label: 'Ghana', mapName: 'Ghana', code: 'GH' },
  { id: 'guinea', label: 'Guinea', mapName: 'Guinea', code: 'GN' },
  { id: 'guinea-bissau', label: 'Guinea-Bissau', mapName: 'Guinea-Bissau', code: 'GW' },
  { id: 'ivory-coast', label: "Ivory Coast (Côte d'Ivoire)", mapName: "Côte d'Ivoire", code: 'CI' },
  { id: 'kenya', label: 'Kenya', mapName: 'Kenya', code: 'KE' },
  { id: 'lesotho', label: 'Lesotho', mapName: 'Lesotho', code: 'LS' },
  { id: 'liberia', label: 'Liberia', mapName: 'Liberia', code: 'LR' },
  { id: 'libya', label: 'Libya', mapName: 'Libya', code: 'LY' },
  { id: 'madagascar', label: 'Madagascar', mapName: 'Madagascar', code: 'MG' },
  { id: 'malawi', label: 'Malawi', mapName: 'Malawi', code: 'MW' },
  { id: 'mali', label: 'Mali', mapName: 'Mali', code: 'ML' },
  { id: 'mauritania', label: 'Mauritania', mapName: 'Mauritania', code: 'MR' },
  { id: 'morocco', label: 'Morocco', mapName: 'Morocco', code: 'MA' },
  { id: 'mozambique', label: 'Mozambique', mapName: 'Mozambique', code: 'MZ' },
  { id: 'namibia', label: 'Namibia', mapName: 'Namibia', code: 'NA' },
  { id: 'niger', label: 'Niger', mapName: 'Niger', code: 'NE' },
  { id: 'nigeria', label: 'Nigeria', mapName: 'Nigeria', code: 'NG' },
  { id: 'rwanda', label: 'Rwanda', mapName: 'Rwanda', code: 'RW' },
  { id: 'senegal', label: 'Senegal', mapName: 'Senegal', code: 'SN' },
  { id: 'sierra-leone', label: 'Sierra Leone', mapName: 'Sierra Leone', code: 'SL' },
  { id: 'somalia', label: 'Somalia', mapName: 'Somalia', code: 'SO' },
  { id: 'south-africa', label: 'South Africa', mapName: 'South Africa', code: 'ZA' },
  { id: 'south-sudan', label: 'South Sudan', mapName: 'S. Sudan', code: 'SS' },
  { id: 'sudan', label: 'Sudan', mapName: 'Sudan', code: 'SD' },
  { id: 'tanzania', label: 'Tanzania', mapName: 'Tanzania', code: 'TZ' },
  { id: 'togo', label: 'Togo', mapName: 'Togo', code: 'TG' },
  { id: 'tunisia', label: 'Tunisia', mapName: 'Tunisia', code: 'TN' },
  { id: 'uganda', label: 'Uganda', mapName: 'Uganda', code: 'UG' },
  { id: 'eswatini', label: 'Eswatini', mapName: 'eSwatini', code: 'SZ' },
  { id: 'zambia', label: 'Zambia', mapName: 'Zambia', code: 'ZM' },
  { id: 'zimbabwe', label: 'Zimbabwe', mapName: 'Zimbabwe', code: 'ZW' },
  { id: 'western-sahara', label: 'Western Sahara', mapName: 'W. Sahara', code: 'EH' },
];

export const europeCountries: Country[] = [
  { id: 'albania', label: 'Albania', mapName: 'Albania', code: 'AL' },
  { id: 'austria', label: 'Austria', mapName: 'Austria', code: 'AT' },
  { id: 'belarus', label: 'Belarus', mapName: 'Belarus', code: 'BY' },
  { id: 'belgium', label: 'Belgium', mapName: 'Belgium', code: 'BE' },
  { id: 'bosnia-herzegovina', label: 'Bosnia and Herzegovina', mapName: 'Bosnia and Herz.', code: 'BA' },
  { id: 'bulgaria', label: 'Bulgaria', mapName: 'Bulgaria', code: 'BG' },
  { id: 'croatia', label: 'Croatia', mapName: 'Croatia', code: 'HR' },
  { id: 'cyprus', label: 'Cyprus', mapName: 'Cyprus', code: 'CY' },
  { id: 'czechia', label: 'Czechia', mapName: 'Czechia', code: 'CZ' },
  { id: 'denmark', label: 'Denmark', mapName: 'Denmark', code: 'DK' },
  { id: 'estonia', label: 'Estonia', mapName: 'Estonia', code: 'EE' },
  { id: 'finland', label: 'Finland', mapName: 'Finland', code: 'FI' },
  { id: 'france', label: 'France', mapName: 'France', code: 'FR' },
  { id: 'germany', label: 'Germany', mapName: 'Germany', code: 'DE' },
  { id: 'greece', label: 'Greece', mapName: 'Greece', code: 'GR' },
  { id: 'hungary', label: 'Hungary', mapName: 'Hungary', code: 'HU' },
  { id: 'iceland', label: 'Iceland', mapName: 'Iceland', code: 'IS' },
  { id: 'ireland', label: 'Ireland', mapName: 'Ireland', code: 'IE' },
  { id: 'italy', label: 'Italy', mapName: 'Italy', code: 'IT' },
  { id: 'kosovo', label: 'Kosovo', mapName: 'Kosovo', code: 'XK' },
  { id: 'latvia', label: 'Latvia', mapName: 'Latvia', code: 'LV' },
  { id: 'lithuania', label: 'Lithuania', mapName: 'Lithuania', code: 'LT' },
  { id: 'luxembourg', label: 'Luxembourg', mapName: 'Luxembourg', code: 'LU' },
  { id: 'moldova', label: 'Moldova', mapName: 'Moldova', code: 'MD' },
  { id: 'montenegro', label: 'Montenegro', mapName: 'Montenegro', code: 'ME' },
  { id: 'netherlands', label: 'Netherlands', mapName: 'Netherlands', code: 'NL' },
  { id: 'north-macedonia', label: 'North Macedonia', mapName: 'Macedonia', code: 'MK' },
  { id: 'norway', label: 'Norway', mapName: 'Norway', code: 'NO' },
  { id: 'poland', label: 'Poland', mapName: 'Poland', code: 'PL' },
  { id: 'portugal', label: 'Portugal', mapName: 'Portugal', code: 'PT' },
  { id: 'romania', label: 'Romania', mapName: 'Romania', code: 'RO' },
  { id: 'serbia', label: 'Serbia', mapName: 'Serbia', code: 'RS' },
  { id: 'slovakia', label: 'Slovakia', mapName: 'Slovakia', code: 'SK' },
  { id: 'slovenia', label: 'Slovenia', mapName: 'Slovenia', code: 'SI' },
  { id: 'spain', label: 'Spain', mapName: 'Spain', code: 'ES' },
  { id: 'sweden', label: 'Sweden', mapName: 'Sweden', code: 'SE' },
  { id: 'switzerland', label: 'Switzerland', mapName: 'Switzerland', code: 'CH' },
  { id: 'ukraine', label: 'Ukraine', mapName: 'Ukraine', code: 'UA' },
  { id: 'united-kingdom', label: 'United Kingdom', mapName: 'United Kingdom', code: 'GB' },
];

export const middleEastCountries: Country[] = [
  { id: 'bahrain', label: 'Bahrain', mapName: 'Bahrain', code: 'BH' },
  { id: 'cyprus', label: 'Cyprus', mapName: 'Cyprus', code: 'CY' },
  { id: 'egypt', label: 'Egypt', mapName: 'Egypt', code: 'EG' },
  { id: 'iran', label: 'Iran', mapName: 'Iran', code: 'IR' },
  { id: 'iraq', label: 'Iraq', mapName: 'Iraq', code: 'IQ' },
  { id: 'israel', label: 'Israel', mapName: 'Israel', code: 'IL' },
  { id: 'jordan', label: 'Jordan', mapName: 'Jordan', code: 'JO' },
  { id: 'kuwait', label: 'Kuwait', mapName: 'Kuwait', code: 'KW' },
  { id: 'lebanon', label: 'Lebanon', mapName: 'Lebanon', code: 'LB' },
  { id: 'oman', label: 'Oman', mapName: 'Oman', code: 'OM' },
  { id: 'qatar', label: 'Qatar', mapName: 'Qatar', code: 'QA' },
  { id: 'saudi-arabia', label: 'Saudi Arabia', mapName: 'Saudi Arabia', code: 'SA' },
  { id: 'syria', label: 'Syria', mapName: 'Syria', code: 'SY' },
  { id: 'turkey', label: 'Turkey', mapName: 'Turkey', code: 'TR' },
  { id: 'united-arab-emirates', label: 'United Arab Emirates', mapName: 'United Arab Emirates', code: 'AE' },
  { id: 'yemen', label: 'Yemen', mapName: 'Yemen', code: 'YE' },
  { id: 'palestine', label: 'Palestine', mapName: 'Palestine', code: 'PS' },
];

export const southAmericaCountries: Country[] = [
  { id: 'argentina', label: 'Argentina', mapName: 'Argentina', code: 'AR' },
  { id: 'bolivia', label: 'Bolivia', mapName: 'Bolivia', code: 'BO' },
  { id: 'brazil', label: 'Brazil', mapName: 'Brazil', code: 'BR' },
  { id: 'chile', label: 'Chile', mapName: 'Chile', code: 'CL' },
  { id: 'colombia', label: 'Colombia', mapName: 'Colombia', code: 'CO' },
  { id: 'ecuador', label: 'Ecuador', mapName: 'Ecuador', code: 'EC' },
  { id: 'guyana', label: 'Guyana', mapName: 'Guyana', code: 'GY' },
  { id: 'paraguay', label: 'Paraguay', mapName: 'Paraguay', code: 'PY' },
  { id: 'peru', label: 'Peru', mapName: 'Peru', code: 'PE' },
  { id: 'suriname', label: 'Suriname', mapName: 'Suriname', code: 'SR' },
  { id: 'uruguay', label: 'Uruguay', mapName: 'Uruguay', code: 'UY' },
  { id: 'venezuela', label: 'Venezuela', mapName: 'Venezuela', code: 'VE' },
];

export const centralAmericaCountries: Country[] = [
  { id: 'mexico', label: 'Mexico', mapName: 'Mexico', code: 'MX' },
  { id: 'belize', label: 'Belize', mapName: 'Belize', code: 'BZ' },
  { id: 'costa-rica', label: 'Costa Rica', mapName: 'Costa Rica', code: 'CR' },
  { id: 'el-salvador', label: 'El Salvador', mapName: 'El Salvador', code: 'SV' },
  { id: 'guatemala', label: 'Guatemala', mapName: 'Guatemala', code: 'GT' },
  { id: 'honduras', label: 'Honduras', mapName: 'Honduras', code: 'HN' },
  { id: 'nicaragua', label: 'Nicaragua', mapName: 'Nicaragua', code: 'NI' },
  { id: 'panama', label: 'Panama', mapName: 'Panama', code: 'PA' },
];

export const usStates: Country[] = [
  { id: 'alabama', label: 'Alabama', mapName: 'Alabama', code: 'AL' },
  { id: 'alaska', label: 'Alaska', mapName: 'Alaska', code: 'AK' },
  { id: 'arizona', label: 'Arizona', mapName: 'Arizona', code: 'AZ' },
  { id: 'arkansas', label: 'Arkansas', mapName: 'Arkansas', code: 'AR' },
  { id: 'california', label: 'California', mapName: 'California', code: 'CA' },
  { id: 'colorado', label: 'Colorado', mapName: 'Colorado', code: 'CO' },
  { id: 'connecticut', label: 'Connecticut', mapName: 'Connecticut', code: 'CT' },
  { id: 'delaware', label: 'Delaware', mapName: 'Delaware', code: 'DE' },
  { id: 'florida', label: 'Florida', mapName: 'Florida', code: 'FL' },
  { id: 'georgia', label: 'Georgia', mapName: 'Georgia', code: 'GA' },
  { id: 'hawaii', label: 'Hawaii', mapName: 'Hawaii', code: 'HI' },
  { id: 'idaho', label: 'Idaho', mapName: 'Idaho', code: 'ID' },
  { id: 'illinois', label: 'Illinois', mapName: 'Illinois', code: 'IL' },
  { id: 'indiana', label: 'Indiana', mapName: 'Indiana', code: 'IN' },
  { id: 'iowa', label: 'Iowa', mapName: 'Iowa', code: 'IA' },
  { id: 'kansas', label: 'Kansas', mapName: 'Kansas', code: 'KS' },
  { id: 'kentucky', label: 'Kentucky', mapName: 'Kentucky', code: 'KY' },
  { id: 'louisiana', label: 'Louisiana', mapName: 'Louisiana', code: 'LA' },
  { id: 'maine', label: 'Maine', mapName: 'Maine', code: 'ME' },
  { id: 'maryland', label: 'Maryland', mapName: 'Maryland', code: 'MD' },
  { id: 'massachusetts', label: 'Massachusetts', mapName: 'Massachusetts', code: 'MA' },
  { id: 'michigan', label: 'Michigan', mapName: 'Michigan', code: 'MI' },
  { id: 'minnesota', label: 'Minnesota', mapName: 'Minnesota', code: 'MN' },
  { id: 'mississippi', label: 'Mississippi', mapName: 'Mississippi', code: 'MS' },
  { id: 'missouri', label: 'Missouri', mapName: 'Missouri', code: 'MO' },
  { id: 'montana', label: 'Montana', mapName: 'Montana', code: 'MT' },
  { id: 'nebraska', label: 'Nebraska', mapName: 'Nebraska', code: 'NE' },
  { id: 'nevada', label: 'Nevada', mapName: 'Nevada', code: 'NV' },
  { id: 'new-hampshire', label: 'New Hampshire', mapName: 'New Hampshire', code: 'NH' },
  { id: 'new-jersey', label: 'New Jersey', mapName: 'New Jersey', code: 'NJ' },
  { id: 'new-mexico', label: 'New Mexico', mapName: 'New Mexico', code: 'NM' },
  { id: 'new-york', label: 'New York', mapName: 'New York', code: 'NY' },
  { id: 'north-carolina', label: 'North Carolina', mapName: 'North Carolina', code: 'NC' },
  { id: 'north-dakota', label: 'North Dakota', mapName: 'North Dakota', code: 'ND' },
  { id: 'ohio', label: 'Ohio', mapName: 'Ohio', code: 'OH' },
  { id: 'oklahoma', label: 'Oklahoma', mapName: 'Oklahoma', code: 'OK' },
  { id: 'oregon', label: 'Oregon', mapName: 'Oregon', code: 'OR' },
  { id: 'pennsylvania', label: 'Pennsylvania', mapName: 'Pennsylvania', code: 'PA' },
  { id: 'rhode-island', label: 'Rhode Island', mapName: 'Rhode Island', code: 'RI' },
  { id: 'south-carolina', label: 'South Carolina', mapName: 'South Carolina', code: 'SC' },
  { id: 'south-dakota', label: 'South Dakota', mapName: 'South Dakota', code: 'SD' },
  { id: 'tennessee', label: 'Tennessee', mapName: 'Tennessee', code: 'TN' },
  { id: 'texas', label: 'Texas', mapName: 'Texas', code: 'TX' },
  { id: 'utah', label: 'Utah', mapName: 'Utah', code: 'UT' },
  { id: 'vermont', label: 'Vermont', mapName: 'Vermont', code: 'VT' },
  { id: 'virginia', label: 'Virginia', mapName: 'Virginia', code: 'VA' },
  { id: 'washington', label: 'Washington', mapName: 'Washington', code: 'WA' },
  { id: 'west-virginia', label: 'West Virginia', mapName: 'West Virginia', code: 'WV' },
  { id: 'wisconsin', label: 'Wisconsin', mapName: 'Wisconsin', code: 'WI' },
  { id: 'wyoming', label: 'Wyoming', mapName: 'Wyoming', code: 'WY' },
];

export const canadaProvinces: Country[] = [
  { id: 'alberta', label: 'Alberta', mapName: 'Alberta', code: 'AB' },
  { id: 'british-columbia', label: 'British Columbia', mapName: 'British Columbia', code: 'BC' },
  { id: 'manitoba', label: 'Manitoba', mapName: 'Manitoba', code: 'MB' },
  { id: 'new-brunswick', label: 'New Brunswick', mapName: 'New Brunswick', code: 'NB' },
  { id: 'newfoundland-and-labrador', label: 'Newfoundland and Labrador', mapName: 'Newfoundland and Labrador', code: 'NL' },
  { id: 'nova-scotia', label: 'Nova Scotia', mapName: 'Nova Scotia', code: 'NS' },
  { id: 'ontario', label: 'Ontario', mapName: 'Ontario', code: 'ON' },
  { id: 'prince-edward-island', label: 'Prince Edward Island', mapName: 'Prince Edward Island', code: 'PE' },
  { id: 'quebec', label: 'Quebec', mapName: 'Quebec', code: 'QC' },
  { id: 'saskatchewan', label: 'Saskatchewan', mapName: 'Saskatchewan', code: 'SK' },
  { id: 'northwest-territories', label: 'Northwest Territories', mapName: 'Northwest Territories', code: 'NT' },
  { id: 'nunavut', label: 'Nunavut', mapName: 'Nunavut', code: 'NU' },
  { id: 'yukon', label: 'Yukon', mapName: 'Yukon', code: 'YT' },
];

export const mexicoStates: Country[] = [
  { id: 'aguascalientes', label: 'Aguascalientes', mapName: 'Aguascalientes', code: 'AGU' },
  { id: 'baja-california', label: 'Baja California', mapName: 'Baja California', code: 'BCN' },
  { id: 'baja-california-sur', label: 'Baja California Sur', mapName: 'Baja California Sur', code: 'BCS' },
  { id: 'campeche', label: 'Campeche', mapName: 'Campeche', code: 'CAM' },
  { id: 'chiapas', label: 'Chiapas', mapName: 'Chiapas', code: 'CHP' },
  { id: 'chihuahua', label: 'Chihuahua', mapName: 'Chihuahua', code: 'CHH' },
  { id: 'coahuila', label: 'Coahuila', mapName: 'Coahuila de Zaragoza', code: 'COA' },
  { id: 'colima', label: 'Colima', mapName: 'Colima', code: 'COL' },
  { id: 'durango', label: 'Durango', mapName: 'Durango', code: 'DUR' },
  { id: 'guanajuato', label: 'Guanajuato', mapName: 'Guanajuato', code: 'GUA' },
  { id: 'guerrero', label: 'Guerrero', mapName: 'Guerrero', code: 'GRO' },
  { id: 'hidalgo', label: 'Hidalgo', mapName: 'Hidalgo', code: 'HID' },
  { id: 'jalisco', label: 'Jalisco', mapName: 'Jalisco', code: 'JAL' },
  { id: 'mexico', label: 'México', mapName: 'México', code: 'MEX' },
  { id: 'michoacan', label: 'Michoacán', mapName: 'Michoacán de Ocampo', code: 'MIC' },
  { id: 'morelos', label: 'Morelos', mapName: 'Morelos', code: 'MOR' },
  { id: 'nayarit', label: 'Nayarit', mapName: 'Nayarit', code: 'NAY' },
  { id: 'nuevo-leon', label: 'Nuevo León', mapName: 'Nuevo León', code: 'NLE' },
  { id: 'oaxaca', label: 'Oaxaca', mapName: 'Oaxaca', code: 'OAX' },
  { id: 'puebla', label: 'Puebla', mapName: 'Puebla', code: 'PUE' },
  { id: 'queretaro', label: 'Querétaro', mapName: 'Querétaro', code: 'QUE' },
  { id: 'quintana-roo', label: 'Quintana Roo', mapName: 'Quintana Roo', code: 'ROO' },
  { id: 'san-luis-potosi', label: 'San Luis Potosí', mapName: 'San Luis Potosí', code: 'SLP' },
  { id: 'sinaloa', label: 'Sinaloa', mapName: 'Sinaloa', code: 'SIN' },
  { id: 'sonora', label: 'Sonora', mapName: 'Sonora', code: 'SON' },
  { id: 'tabasco', label: 'Tabasco', mapName: 'Tabasco', code: 'TAB' },
  { id: 'tamaulipas', label: 'Tamaulipas', mapName: 'Tamaulipas', code: 'TAM' },
  { id: 'tlaxcala', label: 'Tlaxcala', mapName: 'Tlaxcala', code: 'TLA' },
  { id: 'veracruz', label: 'Veracruz', mapName: 'Veracruz de Ignacio de la Llave', code: 'VER' },
  { id: 'yucatan', label: 'Yucatán', mapName: 'Yucatán', code: 'YUC' },
  { id: 'zacatecas', label: 'Zacatecas', mapName: 'Zacatecas', code: 'ZAC' },
  { id: 'mexico-city', label: 'Mexico City', mapName: 'Distrito Federal', code: 'DIF' },
];

export const southAsiaCountries: Country[] = [
  { id: 'afghanistan', label: 'Afghanistan', mapName: 'Afghanistan', code: 'AF' },
  { id: 'bangladesh', label: 'Bangladesh', mapName: 'Bangladesh', code: 'BD' },
  { id: 'bhutan', label: 'Bhutan', mapName: 'Bhutan', code: 'BT' },
  { id: 'india', label: 'India', mapName: 'India', code: 'IN' },
  { id: 'maldives', label: 'Maldives', mapName: 'Maldives', code: 'MV' }, // may not render at 110m
  { id: 'nepal', label: 'Nepal', mapName: 'Nepal', code: 'NP' },
  { id: 'pakistan', label: 'Pakistan', mapName: 'Pakistan', code: 'PK' },
  { id: 'sri-lanka', label: 'Sri Lanka', mapName: 'Sri Lanka', code: 'LK' },
];

export const westCentralAsiaCountries: Country[] = [
  { id: 'armenia', label: 'Armenia', mapName: 'Armenia', code: 'AM' },
  { id: 'azerbaijan', label: 'Azerbaijan', mapName: 'Azerbaijan', code: 'AZ' },
  { id: 'georgia', label: 'Georgia', mapName: 'Georgia', code: 'GE' },
  { id: 'iran', label: 'Iran', mapName: 'Iran', code: 'IR' },
  { id: 'iraq', label: 'Iraq', mapName: 'Iraq', code: 'IQ' },
  { id: 'israel', label: 'Israel', mapName: 'Israel', code: 'IL' },
  { id: 'jordan', label: 'Jordan', mapName: 'Jordan', code: 'JO' },
  { id: 'kazakhstan', label: 'Kazakhstan', mapName: 'Kazakhstan', code: 'KZ' },
  { id: 'kuwait', label: 'Kuwait', mapName: 'Kuwait', code: 'KW' },
  { id: 'kyrgyzstan', label: 'Kyrgyzstan', mapName: 'Kyrgyzstan', code: 'KG' },
  { id: 'lebanon', label: 'Lebanon', mapName: 'Lebanon', code: 'LB' },
  { id: 'oman', label: 'Oman', mapName: 'Oman', code: 'OM' },
  { id: 'qatar', label: 'Qatar', mapName: 'Qatar', code: 'QA' },
  { id: 'saudi-arabia', label: 'Saudi Arabia', mapName: 'Saudi Arabia', code: 'SA' },
  { id: 'syria', label: 'Syria', mapName: 'Syria', code: 'SY' },
  { id: 'tajikistan', label: 'Tajikistan', mapName: 'Tajikistan', code: 'TJ' },
  { id: 'turkey', label: 'Turkey', mapName: 'Turkey', code: 'TR' },
  { id: 'turkmenistan', label: 'Turkmenistan', mapName: 'Turkmenistan', code: 'TM' },
  { id: 'uae', label: 'United Arab Emirates', mapName: 'United Arab Emirates', code: 'AE' },
  { id: 'uzbekistan', label: 'Uzbekistan', mapName: 'Uzbekistan', code: 'UZ' },
  { id: 'yemen', label: 'Yemen', mapName: 'Yemen', code: 'YE' },
  { id: 'palestine', label: 'Palestine', mapName: 'Palestine', code: 'PS' },
];

export const eastSoutheastAsiaCountries: Country[] = [
  { id: 'brunei', label: 'Brunei', mapName: 'Brunei', code: 'BN' }, // may not render at 110m
  { id: 'cambodia', label: 'Cambodia', mapName: 'Cambodia', code: 'KH' },
  { id: 'china', label: 'China', mapName: 'China', code: 'CN' },
  { id: 'indonesia', label: 'Indonesia', mapName: 'Indonesia', code: 'ID' },
  { id: 'japan', label: 'Japan', mapName: 'Japan', code: 'JP' },
  { id: 'laos', label: 'Laos', mapName: 'Laos', code: 'LA' },
  { id: 'malaysia', label: 'Malaysia', mapName: 'Malaysia', code: 'MY' },
  { id: 'mongolia', label: 'Mongolia', mapName: 'Mongolia', code: 'MN' },
  { id: 'myanmar', label: 'Myanmar', mapName: 'Myanmar', code: 'MM' },
  { id: 'north-korea', label: 'North Korea', mapName: 'North Korea', code: 'KP' },
  { id: 'philippines', label: 'Philippines', mapName: 'Philippines', code: 'PH' },
  { id: 'south-korea', label: 'South Korea', mapName: 'South Korea', code: 'KR' },
  { id: 'taiwan', label: 'Taiwan', mapName: 'Taiwan', code: 'TW' },
  { id: 'thailand', label: 'Thailand', mapName: 'Thailand', code: 'TH' },
  { id: 'timor-leste', label: 'Timor-Leste', mapName: 'Timor-Leste', code: 'TL' },
  { id: 'vietnam', label: 'Vietnam', mapName: 'Vietnam', code: 'VN' },
  { id: 'papua-new-guinea', label: 'Papua New Guinea', mapName: 'Papua New Guinea', code: 'PG' },
];

export const oceaniaCountries: Country[] = [
  { id: 'australia', label: 'Australia', mapName: 'Australia', code: 'AU' },
  { id: 'new-zealand', label: 'New Zealand', mapName: 'New Zealand', code: 'NZ' },
  { id: 'fiji', label: 'Fiji', mapName: 'Fiji', code: 'FJ' },
  { id: 'vanuatu', label: 'Vanuatu', mapName: 'Vanuatu', code: 'VU' },
  { id: 'solomon-islands', label: 'Solomon Islands', mapName: 'Solomon Is.', code: 'SB' },
];

export const regions: RegionConfig[] = [
  {
    id: 'africa',
    label: 'Africa',
    countries: africaCountries,
    center: [20, 2],
  },
  {
    id: 'europe',
    label: 'Europe',
    countries: europeCountries,
    center: [10, 55],
  },
  {
    id: 'middle-east',
    label: 'Middle East',
    countries: middleEastCountries,
    center: [45, 27],
    scaleMultiplier: 1.5,
    maxScale: 1200,
  },
  {
    id: 'south-america',
    label: 'South America',
    countries: southAmericaCountries,
    center: [-60, -27],
    scaleMultiplier: 1.0,
    maxScale: 700,
  },
  {
    id: 'central-america',
    label: 'Central America',
    countries: centralAmericaCountries,
    center: [-95, 20],
    scaleMultiplier: 1.4,
    maxScale: 1400,
  },
  {
    id: 'us-states',
    label: 'US States',
    countries: usStates,
    center: [-98, 39],
    geography: usStatesTopo,
    scaleMultiplier: 1.2,
    maxScale: 1400,
    projection: 'geoAlbersUsa',
  },
  {
    id: 'canada-provinces',
    label: 'Canadian Provinces',
    countries: canadaProvinces,
    center: [-95, 65],
    geography: canadaProvincesGeo,
    scaleMultiplier: 0.6,
    maxScale: 850,
  },
  {
    id: 'mexico-states',
    label: 'Mexican States',
  countries: mexicoStates,
  center: [-100, 21],
  geography: mexicoStatesGeo,
  scaleMultiplier: 2.2,
  maxScale: 1800,
  },
  {
    id: 'south-asia',
    label: 'South Asia',
    countries: southAsiaCountries,
    center: [80, 23],
    scaleMultiplier: 1.8,
    maxScale: 1400,
  },
  {
    id: 'west-central-asia',
    label: 'West & Central Asia',
    countries: westCentralAsiaCountries,
    center: [55, 35],
    scaleMultiplier: 1.0,
    maxScale: 900,
  },
  {
    id: 'east-southeast-asia',
    label: 'East & Southeast Asia',
    countries: eastSoutheastAsiaCountries,
    center: [115, 25],
    scaleMultiplier: 1.0,
    maxScale: 700,
  },
  {
    id: 'oceania',
    label: 'Oceania',
    countries: oceaniaCountries,
    center: [145, -25],
    scaleMultiplier: 0.85,
    maxScale: 850,
  },
];

export const regionMap = new Map(regions.map((r) => [r.id, r]));

export const geoData = worldAtlas as unknown as object;
